export default __webpack_public_path__ + "static/media/bihada-factory-profile-mamoru.671b9ac4.png";